import * as React from "react";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Urls";

interface IHeaderBarProps {
    clientId: string;
    name: string;
}

export const HeaderBar = (props: IHeaderBarProps) => {
    return (
        <div className="mb-20">
            <h1 className="mb-0">
                <span>{props.name} </span>
            </h1>
            <div>Customer ID: {props.clientId}</div>
            {checkPermission(UserClaim.AdviserPortalClientSummaryCanView) && (
                <div className="mb-10 mt-10">
                    <a
                        onClick={() => {
                            Navigator.navigateTo(
                                Urls.get().main.PortfolioDashboard({
                                    hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                        HierarchyLevelName.Customer,
                                        Number(props.clientId)
                                    ),
                                }).summary
                            );
                        }}
                        className="hyperlink-previous"
                    >
                        <span className="icon" aria-hidden={true}></span>
                        <span className="text">Back to summary</span>
                    </a>
                </div>
            )}
        </div>
    );
};
